<template>
  <div class="areaText">
    <el-timeline>
      <el-timeline-item
        :timestamp="item.times"
        placement="top"
        v-for="(item, index) in list"
        :key="index"
      >
        <el-card>
          <div class="imggs flex">
            <el-image
              :src="item.pic"
              :preview-src-list="imgList"
              class="imgs"
            ></el-image>
          </div>
          <div class="wzDiv">
            {{ item.content }}
          </div>
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["graphic"])
  },
  data() {
    return {
      imgList: [],
      list: [
        {
          content: "正大集团中国区总部所在地一正大中心投入使用。",
          pic: require("images/index/home/2020pigc.png"),
          times: "2020年"
        },
        {
          content:
            "正大集团谢国民资深董事长当选中华海外联谊会名誉副会长;正大集团谢国民资深董事长当选中国侨商联合会会长、谢吉人董事长当选中国侨商联合会常务副会长;正大集团谢国民资深董事长、谢吉人董事长参加庆祝中华人民共和国成立70周年招待会、庆祝大会和联欢活动并观礼阅兵;习近平主席会见正大集团谢吉人董事长等出席第二届中国国际进口博览会开幕式的世界知名企业家代表;",
          pic: require("images/index/home/2019pigc.png"),
          times: "2019年"
        },
        {
          content:
            "正大集团谢国民资深董事长出席博鳌亚洲论坛2018年年会并发言;正大集团谢国民资深董事长、谢吉人董事长出席首届中国国际进口博览会;",
          pic: require("images/index/home/2018pigc.png"),
          times: "2018年"
        },
        {
          content:
            "经谢国民先生提议,正大集团董事会决议谢国民先生任正大集团资深董事长,由谢吉人先生出任正大集团董事长、谢铬仁先生出任正大集团CEO;正大集团谢国民资深董事长连续四届当选中国侨商投资企业协会会长;正大集团谢国民资深董事长与其他8位华侨,作为“一带一路”沿线国家侨界代表, 出席“一带一路国际合作高峰论坛”并发言；",
          pic: require("images/index/home/2017pigc.png"),
          times: "2017年"
        },
        {
          content:
            "正大集团与阿里巴巴及蚂蚁金服,在农牧食品、电子商务、金融服务、农业服务、物流、商业零售及精准扶贫方面达成战略合作关系;",
          pic: require("images/index/home/2016pigc.png"),
          times: "2016年"
        },
        {
          content:
            "正大集团联手伊藤忠商事株式会社入股中信集团,成第二大股东;正大集团、中国移动、中信集团、上海信投、伊藤忠设立“见见面”公司,进军跨境电商业务;正大集团谢国民资深董事长与其他四位华侨,作为6000万海外华人华侨代表,登上天安门城楼,参加中国人民抗日战争暨世界反法西斯战争胜利70周年大阅兵;",
          pic: require("images/index/home/2015pigc.png"),
          times: "2015年"
        },
        {
          content:
            "正大与上汽合资，在泰国设厂生产“MG”汽车；中国移动入股正大旗下电信企业TRUE,成第二大股东；",
          pic: require("images/index/home/2014pigc.png"),
          times: "2014年"
        },
        {
          content:
            "正大集团投资中国平安保险（集团）股份有限公司，成为第一大股东；",
          pic: require("images/index/home/2012pigc.png"),
          times: "2012年"
        },
        {
          content:
            "正大广场正式营业，是国内第一座正式意义上的一站式购物商业旗舰，也是上海陆家嘴金融区地标性建筑之一；",
          pic: require("images/index/home/2002pigc.png"),
          times: "2002年"
        },
        {
          content: "旗下正大制药集团的“中国生物制药有限公司”在香港成功上市；",
          pic: require("images/index/home/2000pigc.png"),
          times: "2000年"
        },
        {
          content: "正大集团零售品牌卜峰莲花第一家门店落户上海浦东；",
          pic: require("images/index/home/1997pigc.png"),
          times: "1997年"
        },
        {
          content:
            "正大集团成立正大国际财务有限公司，是中国境内经政府批准最早设立的外商独资国际金融机构；",
          pic: require("images/index/home/1992pigc.png"),
          times: "1992年"
        },
        {
          content:
            "中国改革开发总设计师邓小平会见正大集团谢国民资深董事长；正大集团联合中央电视台，推出《正大综艺》，陪伴中国人成长至今；",
          pic: require("images/index/home/1990pigc.png"),
          times: "1990年"
        },
        {
          content: "合资建成中国第一家“一条龙”大型农牧企业--上海大江有限公司；",
          pic: require("images/index/home/logo.png"),
          times: "1985年"
        },
        {
          content: "成立吉林正大有限公司，中国饲料行业第一家中外合资企业；",
          pic: require("images/index/home/logo.png"),
          times: "1984年"
        },
        {
          content:
            "正大集团进入中国发展农牧业,并在深圳成功注册了中国大陆首家外资企业,获批准证书“深外资证字0001号”;",
          pic: require("images/index/home/1979pigc.png"),
          times: "1979年"
        },
        {
          content:
            "华侨谢易初在泰国创办正大庄种子行;上世纪60年代,在东南亚和香港设立分支机构;上世纪70年代,业务拓展到美国、中东和中国台湾地区;",
          pic: require("images/index/home/logo.png"),
          times: "1921年"
        }
      ]
    };
  },
  mounted() {
    this.imgList.push(this.pic);
    this.list.map(it => {
      this.imgList.push(it.pic);
    });
  },
  methods: {}
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.imggs
  width 30%
.wzDiv
  width calc(70% - 30px)
  height calc(100% - 10px)
  padding 5px 15px
  letter-spacing 2px
  line-height 24px
  overflow-y auto
  &::-webkit-scrollbar
    width 3px
  /* 定义滚动条轨道 内阴影+圆角 */
  &::-webkit-scrollbar-track
    -webkit-box-shadow inset 0 0 6px transparent
    background-color transparent
  /* 定义滑块 内阴影+圆角 */
  &::-webkit-scrollbar-thumb
    border-radius 10px
    -webkit-box-shadow inset 0 0 6px transparent
    background-color $textColor
  /* 定义最上方和最下方的按钮 */
  &::-webkit-scrollbar-button
    height 0
.areaText
  padding 0 5px
  height calc(100% - 5px)
  overflow-y auto
  width calc(100% - 10px)
  >>>.el-card
    background rgba(10, 37, 80, 0.7)
    box-shadow 0px 0px 15px #0B4378 inset
    border 1px #0B4378 solid
    color #fff
  >>>.el-timeline-item__tail
    border-left 2px solid #0592B3
  >>>.el-timeline-item__node
    background-color #075B80
    box-shadow 0 0 12px #01e1fb inset
  >>>.el-timeline-item__node--normal
    left -3px
    width 15px
    height 15px
  >>>.el-timeline-item__timestamp
    color #fff
    line-height 1
    font-size 15px
  >>>.el-card__body
    padding 2px
    display flex
    flex-wrap wrap
    align-items center
  >>>.el-timeline-item
    padding-bottom 10px
  &::-webkit-scrollbar
    width 3px
  /* 定义滚动条轨道 内阴影+圆角 */
  &::-webkit-scrollbar-track
    -webkit-box-shadow inset 0 0 6px transparent
    background-color transparent
  /* 定义滑块 内阴影+圆角 */
  &::-webkit-scrollbar-thumb
    border-radius 10px
    -webkit-box-shadow inset 0 0 6px transparent
    background-color $textColor
  /* 定义最上方和最下方的按钮 */
  &::-webkit-scrollbar-button
    height 0
.imgs
  width 100%
@media (max-width 1280px)
  .wzDiv
    width calc(70% - 10px)
    height calc(100% - 6px)
    padding 3px 5px
    font-size 0.1rem
    line-height 16px
  .areaText>>>.el-timeline-item__timestamp
    font-size 0.1rem
  .areaText>>>.el-timeline-item__wrapper
    padding-left 16px
  .areaText>>>.el-timeline-item__node--normal
    left -0.5px
    width 10px
    height 10px
</style>
<style lang="stylus">
.info p
  color #fff !important
</style>
